import { useMemo } from 'react';

import { color, Table } from '@wf/components';

import useComparisonValues from '../../hooks/useComparisonValues';

function ComparisonTableCell({
  path,
  value,
  render,
}: {
  path: string;
  value: string | null;
  render?: (value: string) => string;
}) {
  const { newValue, valueHasChanged } = useComparisonValues({ path, value });

  const formattedValue = useMemo(() => {
    if (!newValue) {
      return '-';
    }

    if (render) {
      return render(newValue as string);
    }

    return newValue;
  }, [newValue, render]);

  return (
    <Table.Cell style={{ color: valueHasChanged ? color('success', -10) : undefined }}>
      {formattedValue as string}
    </Table.Cell>
  );
}

export default ComparisonTableCell;
